import { Button, Card, Grid, Modal, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import CancelIcon from '../../../icons/close.svg';
import { getUpdateWorkOrderDetails } from '../sagas/workorderSlice';
import Tick from '../../../icons/Tick.svg';
import { UpdateWorkOrderDto, WorkOrderStatusEnum } from '@inosio/payments-sdk';

export interface CompleteWorkOrderConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  WorkOrderUuid: string;
  status?: WorkOrderStatusEnum;
  disposition?: string;
}
export default function WorkOrderStatusConfirmationModal(props: CompleteWorkOrderConfirmationModalProps) {
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    height: '523px',
    pointerEvents: "auto",
    width: '98%',
    maxWidth: '472px',
    borderRadius: '24px',
    outline: 'none',
  };

  const buttonStyle = (color: string) => {
    return {
      textTransform: 'none',
      fontFamily: "'Open Sans', sans-serif",
      fontStyle: 'normal',
      fontWeight: 700,
      backgroundColor: color,
      borderRadius: '24px',
      width: '90px',
      height: '42px',
      margin: '4px',
    };
  };

  const dispatch = useDispatch();
  return (
    <div style={{ background: "#FFFFFF", boxShadow: "none", borderRadius: "24px" }}>
      <Modal
        open={props.open}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{
          invisible: false,
        }}
        disableEscapeKeyDown
        disableAutoFocus={true}
      >
        <Card sx={style}>
          <Grid container height="100%" width="100%" display="flex" justifyContent="center">
            <Grid item xs={12} display="flex" justifyContent="center">
              <Typography
                sx={{
                  fontFamily: 'Work Sans !important',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  fontSize: '18px !important',
                  lineHeight: '21px !important',
                  color: '#14142B',
                }}
              >
                {`Confirm ${props.status}`}
              </Typography>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="center">
              <img src={Tick} style={{ height: '148px', width: '148px' }} alt="Tick" />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="center">
              <Typography
                sx={{
                  fontFamily: 'Work Sans',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '18px',
                  color: '#14142B',
                  marginRight: '10px',
                }}
                textAlign="center"
              >
                {`The request will be marked as ${props.status}.`}
              </Typography>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="center">
              <Typography
                sx={{
                  fontFamily: 'Work Sans',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '18px',
                  color: '#14142B',
                  marginRight: '10px',
                }}
                textAlign="center"
              >
                Are you sure you want to proceed?
              </Typography>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="center">
              {/* Confirmation buttons */}
              <Button
                variant="contained"
                sx={buttonStyle('#A2DBFA')}
                onClick={() => {
                  dispatch({
                    type: getUpdateWorkOrderDetails.type,
                    payload: {
                      woUuid: props.WorkOrderUuid,
                      updateWoDto: {
                        Status: props.status,
                        Disposition: props.disposition,
                      } as UpdateWorkOrderDto,
                    },
                  });
                  props.onClose();
                }}
              >
                Yes
              </Button>
              <Button
                variant="contained"
                sx={buttonStyle('#39A2DB')}
                onClick={() => {
                  props.onClose();
                }}
              >
                No
              </Button>
            </Grid>
            {/* Close Icon */}
            <Grid item sx={{ position: 'absolute', top: 18, right: 20 }}>
              <img
                src={CancelIcon}
                alt="close"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  props.onClose();
                }}
              />
            </Grid>
          </Grid>
        </Card>
      </Modal>
    </div>
  );
}
